export function validateSIRENOrSIRET(number) {
  if (number.length !== 9 && number.length !== 14) { // Vérifier que le numéro est bien soit un SIREN (9 chiffres), soit un SIRET (14 chiffres)
    return false;
  }

  // Appliquer l'algorithme de Luhn pour vérifier le SIRET
  let sum = 0;
  let tmp;

  const length = number.length; // Longueur du numéro (9 ou 14) pour déterminer la limite de la boucle
  for (let i = 0; i < length; i++) {
    tmp = parseInt(number[i], 10);
    // Double chaque chiffre d'indice impair pour le SIRET ou SIREN
    if (i % 2 === (length === 14 ? 0 : 1)) {  // Pour SIRET (14 chiffres), les indices pairs, pour SIREN les indices impairs
      tmp *= 2;
      if (tmp > 9) {
        tmp -= 9;
      }
    }

    sum += tmp;
  }
  return sum % 10 === 0; // Le numéro est valide si la somme est un multiple de 10
}

export function validateIDE(ide) { // Suisse
  if (ide.length !== 9) { // Vérifier que le numéro est bien une chaîne de 9 chiffres
    return false
  }
  return true
  let sum = 0;
  const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3]; // Poids pour chaque position

  // Calculer la somme pondérée
  for (let i = 0; i < 9; i++) {
    sum += parseInt(ide[i], 10) * weights[i];
  }

  // Vérifier la condition du modulo 11
  return sum % 11 === 0;
}

export function validateBCE(bce) { // Belgique
  if (bce.length !== 10) { // Vérifier que le numéro est bien une chaîne de 10 chiffres
    return false;
  }

  // Extraire les 9 premiers chiffres et les convertir en nombre
  const base = parseInt(bce.slice(0, 8), 10);
  const checksum = parseInt(bce.slice(8), 10);
  const calculatedChecksum = 97 - (base % 97); // Calculer la clé de contrôle avec le modulo 97

  // Comparer la clé calculée à celle donnée
  return calculatedChecksum === checksum;
}